import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";

import { OKTA_AUTH, OKTA_CONFIG, OktaConfig } from "@okta/okta-angular";
import { OktaAuth, Tokens } from '@okta/okta-auth-js';
//import * as OktaSignIn from "@okta/okta-signin-widget";
// @ts-ignore
import OktaSignIn from '@okta/okta-signin-widget';
import { AppConfigService } from "@tmhcc/global-services";
import { getBaseUrl } from "libs/util/string-util";
import { environment } from '../../../../../apps/policy-admin/src/environments/environment';
const DEFAULT_ORIGINAL_URI = window.location.origin;
@Component({
    selector: "app-secure",
    template: `
    <!-- Container to inject the Sign-In Widget -->
    <div id="okta-signin-container"></div>
  `,
    standalone: false
})
export class OktaLoginComponent implements OnDestroy {
  signIn;
  widget;

  constructor(
    private router: Router,
    protected configService: AppConfigService,
    @Inject(OKTA_CONFIG) protected config: OktaConfig,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) {
    this.signIn = new OktaSignIn({
      /**
       * Note: when using the Sign-In Widget for an OIDC flow, it still
       * needs to be configured with the base URL for your Okta Org. Here
       * we derive it from the given issuer for convenience.
       */
      baseUrl: environment.oidc.issuer.split('/oauth2')[0],
      clientId: environment.oidc.clientId,
      redirectUri: environment.oidc.redirectUri,
      logo: '/assets/images/logo-tmhcc.svg',
      i18n: {
        en: {
          'primaryauth.title': 'Sign In',
        },
      },
      authClient: oktaAuth,
      useClassicEngine: true,
    });
  }

  async ngOnInit() {
    if (document.getElementById('topheader')) {
      document.getElementById("topheader").classList.add("hide");
    }
    const authenticated = await this.oktaAuth.isAuthenticated();
    if (authenticated) {
      // await this.oktaAuth.signOut();
      await this.oktaAuth.signOut({postLogoutRedirectUri: "login"});
      this.oktaAuth.tokenManager.clear();
    } else {
      const originalUri = this.oktaAuth.getOriginalUri();

        if (!originalUri || originalUri === DEFAULT_ORIGINAL_URI) {
          this.oktaAuth.setOriginalUri('/');
        }
        this.signIn.showSignInToGetTokens({
          el: '#okta-signin-container',
          scopes: environment.oidc.scopes
        }).then(async (tokens: Tokens) => {
          // Remove the widget
          this.signIn.remove();
          // In this flow the redirect to Okta occurs in a hidden iframe
          this.oktaAuth.handleLoginRedirect(tokens);
          const userClaims = await this.oktaAuth.getUser();
          sessionStorage.setItem('UserId', userClaims.name);
          //remove hide class from top header
          document.getElementById('topheader').classList.remove('hide');
          document.getElementById('headerUserName').textContent = userClaims.name;

        }).catch((err: any) => {
          // Typically due to misconfiguration
          throw err;
        });
    }
  }
  ngOnDestroy() {
    this.signIn.remove();
  }
}
